export default {
  paper: {
    padding: "1.5rem 0",
    background: "#f8f8f8",
  },
};
